import OrderTotals, { OrderTotalRow } from "~/feature/cart/cart/components/CartPage/OrderTotals";
import { Permission, userHasPermission } from "../../../utils/permissions";
import { type PriceData } from "../../../models/PriceData";
import { type WeightData } from "../../../models/WeightData";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface QuoteSummaryTotalsProps {
  totalValue: PriceData;
  totalSelectableValue: PriceData;
  totalSelectableWeight: WeightData;
  className?: string;
  surcharge?: PriceData;
}

const QuoteSummaryTotals = (props: QuoteSummaryTotalsProps) => {
  const { t } = useTranslation();
  return (
    <div className={props.className}>
      <OrderTotals
        showPriceOnRequest={false}
        totalValue={props.totalSelectableValue}
        weight={props.totalSelectableWeight}
        taxInNewLine={true}
        additionalMsg={t("quoteDetailsPage.summary.disclaimer.totalSelectable")}
        customTaxMsg={t("orderDetailsPage.summary.disclaimer")}
        surcharge={props.surcharge}
      />
      {userHasPermission(Permission.ADD_TO_QUOTE) && (
        <OrderTotalRow
          showPriceOnRequest={false}
          value={props.totalValue}
          taxInNewLine={true}
          additionalMsg={t("quoteDetailsPage.summary.disclaimer.total")}
          customTaxMsg={t("orderDetailsPage.summary.disclaimer")}
        />
      )}
    </div>
  );
};

export default memo(QuoteSummaryTotals);
